import { createReducer, on } from '@ngrx/store';
import { ContactState } from '../../models/contact.model';
import * as ContactActions from './contact.actions';

export const initialContactState: ContactState = {
  inquiries: [],
  currentInquiry: null,
  loading: false,
  submitting: false,
  error: null,
  success: false,
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0
};

export const contactReducer = createReducer(
  initialContactState,
  on(ContactActions.submitContactInquiry, state => ({
    ...state,
    submitting: true,
    error: null,
    success: false
  })),
  on(ContactActions.submitContactInquirySuccess, (state, { inquiry }) => ({
    ...state,
    submitting: false,
    currentInquiry: inquiry,
    success: true,
    error: null
  })),
  on(ContactActions.submitContactInquiryFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    success: false,
    error
  })),
  on(ContactActions.getContactInquiries, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(ContactActions.getContactInquiriesSuccess, (state, { page }) => ({
    ...state,
    loading: false,
    inquiries: page.result,
    pageNumber: page.pageNumber,
    pageSize: page.pageSize,
    totalRecords: page.totalRecords,
    error: null
  })),
  on(ContactActions.getContactInquiriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(ContactActions.getContactInquiryById, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(ContactActions.getContactInquiryByIdSuccess, (state, { inquiry }) => ({
    ...state,
    loading: false,
    currentInquiry: inquiry,
    error: null
  })),
  on(ContactActions.getContactInquiryByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(ContactActions.resetContactState, () => initialContactState)
);
